<avi-alert-group
    alertType="danger"
    class="full-modal-config-errors"
    #alertGroup
>
    {{ errorMessage }}
</avi-alert-group>
